<template>
  <div class="success-style" id="verifySucceeded">
    <template v-if="activeType=='setAccount' || activeType=='upAccount'">
      <div class="y-mt-30 y-f y-f-jc y-f-a">
        <img slot="reference" src="@/assets/images/icon_success@2x.png" class="success-icon y-mr-10"/>
        <span class="success-tip">验证成功</span>
      </div>
      <div class="y-mt-25 y-f y-f-jc">
        <span class="success-info" v-if="activeType=='setAccount'">未设置收款账号，请前往支付宝进行授权</span>
        <span class="success-info" v-if="activeType=='upAccount'">修改收款账号，请前往支付宝进行授权</span>
      </div>
      <div class="y-mt-40 y-f y-f-jc">
        <el-button class="y-w-100" @click="close">取消</el-button>
        <el-button type="primary" @click="toAlipay">去授权支付宝账号</el-button>
      </div>
    </template>
    <template v-if="activeType=='showAccount'">
      <div class="y-mt-30 y-f y-f-jc y-f-a">
        <img slot="reference" src="@/assets/images/icon_success@2x.png" class="success-icon y-mr-10"/>
        <span class="success-tip">收款账号设置成功</span>
      </div>
      <div class="y-mt-40 y-f y-f-jc">
        <el-button class="y-w-100" @click="close">我知道了</el-button>
        <el-button type="primary" @click="toSetting">查看收款账号</el-button>
      </div>
    </template>
    <template v-if="activeType=='unBindAccount'">
      <div class="y-mt-30 y-f y-f-jc y-f-a">
        <img slot="reference" src="@/assets/images/icon_success@2x.png" class="success-icon y-mr-10"/>
        <span class="success-tip">收款账号解绑成功</span>
      </div>
      <div class="y-mt-40 y-f y-f-jc">
        <el-button class="y-w-100" @click="close">我知道了</el-button>
      </div>
    </template>
    <template v-if="activeType=='errorAccount'">
      <div class="y-mt-30 y-f y-f-jc y-f-a">
        <img slot="reference" src="@/assets/images/icon_error@2x.png" class="success-icon y-mr-10"/>
        <span class="success-tip">验证失败</span>
      </div>
      <div class="y-mt-40 y-f y-f-jc">
        <el-button class="y-w-100" @click="close">取消</el-button>
        <el-button type="primary" class="y-w-100" @click="toSetting">重新验证</el-button>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  name: 'verifySucceeded',
  props: {
    activeType: {
      type: String,
      default: 'setAccount'
    },
    authCode: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  created() {
   
  },
  mounted() {},
  methods: {
    // 支付宝授权
    toAlipay() {
     let apiOrigin = window.location.origin;
      // let apiOrigin = 'https://kh.yto.net.cn';
      // let apiOrigin = 'https://kh-test.yto56test.com';//uat
      window.open('https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021002174632096&scope=auth_base&redirect_uri=' + apiOrigin + '/new/claimWorkOrder&state='+this.authCode, '_blank');
      this.close();
    },
    close(){
      this.$nextTick(() => {
        this.$emit('close');
      })
    },
    toSetting(){
      this.$nextTick(() => {
        this.$emit('toSetting');
      })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
#verifySucceeded{
  .success-icon{
    width: 60px;
    height: 60px;
  }
  .success-info{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }
  .success-tip{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
  }
}
</style>
